export enum AQStationTypeEnum {
  STATION = 'STATION',
  MINI_STATION = 'MINI_STATION'
}
